const ArrowButton = ({ onClick, role }) => (
    <div className={`arrow ${role}`}>
        <button onClick={onClick} aria-label={`arrow-${role}`} />
    </div>
)

export default ArrowButton
